/* Add/Edit student modal — extracted from Students.js (2026-02 refactor).
 * Pure presentational — form state managed by parent. */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Switch } from '../ui/switch';

export default function StudentFormDialog({
  open, onOpenChange, selectedStudent, formData, setFormData,
  onSubmit, classes, cycles, t, onToggleEnrollment,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-outfit text-xl">
            {selectedStudent ? t('editStudent') : t('addStudent')}
          </DialogTitle>
        </DialogHeader>
        {selectedStudent && onToggleEnrollment && (
          <div className="flex items-center justify-between rounded-lg border border-emerald-100 bg-emerald-50/50 p-3" data-testid="enrollment-status-row">
            <div>
              <Label className="font-manrope font-semibold">Statut d&apos;inscription</Label>
              <p className="text-xs text-[#64748B]">
                {selectedStudent.is_new === false
                  ? 'Réinscrit — frais d\u2019inscription non facturés'
                  : 'Nouveau — frais d\u2019inscription facturés'}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <span className={`text-xs font-medium ${selectedStudent.is_new === false ? 'text-emerald-700' : 'text-[#94A3B8]'}`}>Réinscrit</span>
              <Switch
                checked={selectedStudent.is_new === false}
                onCheckedChange={(v) => onToggleEnrollment(v)}
                data-testid="enrollment-status-switch"
              />
            </div>
          </div>
        )}
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label className="font-manrope">{t('firstName')}</Label>
              <Input
                value={formData.first_name}
                onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                required className="border-[#E2E8F0]" data-testid="student-firstname"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('lastName')}</Label>
              <Input
                value={formData.last_name}
                onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                required className="border-[#E2E8F0]" data-testid="student-lastname"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('fatherName')}</Label>
              <Input
                value={formData.father_name}
                onChange={(e) => setFormData({ ...formData, father_name: e.target.value })}
                className="border-[#E2E8F0]"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('motherName')}</Label>
              <Input
                value={formData.mother_name}
                onChange={(e) => setFormData({ ...formData, mother_name: e.target.value })}
                className="border-[#E2E8F0]"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('parentContact')}</Label>
              <Input
                value={formData.parent_contact}
                onChange={(e) => setFormData({ ...formData, parent_contact: e.target.value })}
                className="border-[#E2E8F0]"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('email')}</Label>
              <Input
                type="email" value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="border-[#E2E8F0]"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('nationality')}</Label>
              <Input
                value={formData.nationality}
                onChange={(e) => setFormData({ ...formData, nationality: e.target.value })}
                className="border-[#E2E8F0]"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('dateOfBirth')}</Label>
              <Input
                type="date" value={formData.date_of_birth}
                onChange={(e) => setFormData({ ...formData, date_of_birth: e.target.value })}
                className="border-[#E2E8F0]"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">Lieu de naissance</Label>
              <Input
                value={formData.birth_place}
                onChange={(e) => setFormData({ ...formData, birth_place: e.target.value })}
                className="border-[#E2E8F0]" placeholder="Ex: Abidjan"
                data-testid="student-birth-place"
              />
            </div>
            {/* iter97 — Genre (sexe) et photo élève */}
            <div className="space-y-2">
              <Label className="font-manrope">Sexe</Label>
              <Select
                value={formData.gender || ''}
                onValueChange={(v) => setFormData({ ...formData, gender: v })}
              >
                <SelectTrigger className="border-[#E2E8F0]" data-testid="student-gender">
                  <SelectValue placeholder="Sélectionner" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="M">Masculin</SelectItem>
                  <SelectItem value="F">Féminin</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2 md:col-span-2">
              <Label className="font-manrope">Photo</Label>
              <div className="flex items-center gap-3">
                {formData.photo_base64 && (
                  <img src={formData.photo_base64} alt=""
                    className="w-16 h-16 rounded-full object-cover border border-[#E2E8F0]" />
                )}
                <Input type="file" accept="image/*"
                  data-testid="student-photo-input"
                  onChange={async (e) => {
                    const f = e.target.files?.[0]; if (!f) return;
                    if (!/^image\/(jpeg|jpg|png|webp)$/i.test(f.type)) {
                      alert('Format non supporté (JPG/PNG/WebP)'); return;
                    }
                    if (f.size > 5 * 1024 * 1024) {
                      alert('Photo trop volumineuse (>5 Mo)'); return;
                    }
                    const { compressImage } = await import('../../lib/imageCompress');
                    const r = await compressImage(f, { maxSide: 320, quality: 0.85 });
                    setFormData({ ...formData, photo_base64: r.dataUrl });
                  }}
                  className="border-[#E2E8F0]" />
                {formData.photo_base64 && (
                  <button type="button"
                    className="text-xs text-red-600 hover:underline"
                    onClick={() => setFormData({ ...formData, photo_base64: '' })}>
                    Retirer
                  </button>
                )}
              </div>
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('cycle')}</Label>
              <Select
                value={formData.cycle}
                onValueChange={(v) => setFormData({ ...formData, cycle: v })}
              >
                <SelectTrigger className="border-[#E2E8F0]" data-testid="student-cycle">
                  <SelectValue placeholder={t('cycle')} />
                </SelectTrigger>
                <SelectContent>
                  {cycles.map((c) => (
                    <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{t('class')}</Label>
              <Select
                value={formData.class_id}
                onValueChange={(v) => setFormData({ ...formData, class_id: v })}
              >
                <SelectTrigger className="border-[#E2E8F0]" data-testid="student-class">
                  <SelectValue placeholder={t('class')} />
                </SelectTrigger>
                <SelectContent>
                  {classes
                    .filter((c) => !formData.cycle || c.cycle === formData.cycle)
                    .map((c) => (
                      <SelectItem key={c.id} value={c.name}>{c.name}</SelectItem>
                    ))}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="space-y-2">
            <Label className="font-manrope">{t('address')}</Label>
            <Input
              value={formData.address}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              className="border-[#E2E8F0]"
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              {t('cancel')}
            </Button>
            <Button type="submit" className="bg-[#0052FF] hover:bg-[#0043D1]" data-testid="save-student-btn">
              {t('save')}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
